(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CompaniesEditController', companies);

  companies.$inject = ['$http', '$stateParams', '$state', 'FoundationApi', 'Upload', '$timeout'];

  function companies ($http, $stateParams, $state, FoundationApi, Upload, $timeout) {
    var vm = this;

    vm.company = {};
    vm.channels = [];
    vm.company_channels = [];

    vm.creating_user = {};
    vm.editting_user = {};
    vm.selectedSectors = [];

    vm.selected_channel = undefined;
    vm.selected_sector = undefined;

    vm.channelsSelect = [];

    vm.copyTo = undefined;
    vm.copyFrom = '';

    vm.pickChannelModal = function (channelId) {
      vm.copyTo = channelId;
      FoundationApi.publish('copyTemplate', 'open');
    };

    vm.pickCompanyChannelModal = function (channelId) {
      vm.copyTo = channelId;
      FoundationApi.publish('useTriggersFrom', 'open');
    };

    vm.useTriggers = function () {
      $http.patch(apiUrl + '/channels/' + vm.copyTo, {
        use_trigger_from_channel_id: vm.copyFrom ? vm.copyFrom : null
      }).then(function () {
        $state.reload();
      }, function (error) { console.log(error) });
    };

    vm.copyTriggers = function () {
      if (vm.copyTo == vm.copyFrom) return false;
      if (!vm.copyTo || !vm.copyFrom) return false;

      $http.patch(apiUrl + '/triggers/copy-triggers', {
        from: vm.copyFrom,
        to: vm.copyTo
      }).then(function () {
        $state.go('main.interactive-channel', { id: vm.copyTo });
      }, function (error) { console.log(error) })
    };

    vm.updateStatus = function (user) {
      vm.editting_user = user;
      vm.saveUser();
    };

    vm.fetchCompany = function (companyId) {
      $http.get(apiUrl + '/companies/' + companyId).then(function (response) {
        vm.company = response.data;
        vm.fetchCompanyChannels();
      }, function (error) { console.log(error) });
    };

    vm.fetchAllChannels = function () {
      $http.get(apiUrl + '/channels')
        .then(function (response) {
          vm.channelsSelect = response.data;
        }, function (error) { console.log(error) });
    };

    vm.updateCompany = function () {
      $http.patch(apiUrl + '/companies/' + vm.company.id, vm.company)
        .then(function () {
          $state.reload();
        }, function (error) { console.log(error) });
    };

    vm.addSector = function () {
      if (!angular.isArray(vm.company.sectors) && !angular.isDefined(vm.company.sectors)) {
        vm.company.sectors = [];
      }
      vm.company.sectors.push({});
    };

    vm.deleteSector = function (index) {
      vm.company.sectors.splice(index, 1);
    };

    vm.fetchChannels = function () {
      $http.get(apiUrl + '/channels?available=true')
        .then(function (response) {
          vm.channels = response;
        }, function (error) { console.log(error) });
    };

    vm.fetchCompanyChannels = function () {
      $http.get(apiUrl + '/channels/company/' + vm.company.id)
        .then(function (response) {
          vm.company_channels = response.data;
        }, function (error) { console.log(error) });
    };

    vm.associate = function () {
      if (!vm.selected_sector || !vm.selected_channel) return false;

      $http.patch(apiUrl + '/channels/' + vm.selected_channel, {
        default_sector_id: vm.selected_sector,
        company_id: vm.company.id,
        status_message: vm.company.default_status,
        profile_picture_path: vm.company.default_image.name || null
      }).then(function () {
        vm.fetchChannels();
        vm.fetchCompanyChannels();

        vm.selected_sector = '';
        vm.selected_channel = '';
      }, function (error) { console.log(error) })
    };

    vm.freeChannel = function (channelId) {
      $http.patch(apiUrl + '/channels/' + channelId, {
        default_sector_id: 0,
        company_id: null,
        status_message: '',
        profile_picture_path: null
      }).then(function () {
        vm.fetchChannels();
        vm.fetchCompanyChannels();

        vm.selected_sector = '';
        vm.selected_channel = '';
      }, function (error) { console.log(error) });
    };

    vm.manageSectors = function (user) {
      vm.editting_user = user;

      for (var i = 0; i < vm.company.sectors.length; i++) {
        vm.selectedSectors[vm.company.sectors[i].id] = vm.belongsToSector(vm.editting_user, vm.company.sectors[i].id);
      };

      FoundationApi.publish('userSectorsModal', 'open');
    };

    vm.editUser = function (user) {
      vm.editting_user = user;

      FoundationApi.publish('userEditModal', 'open');
    };

    vm.belongsToSector = function (user, sectorId) {
      if (!user.sectors) return false;

      var belongs = false;

      for (var i = user.sectors.length - 1; i >= 0; i--) {
        if (user.sectors[i].id == sectorId) {
          belongs = true;
          break;
        };
      };

      return belongs;
    };

    vm.saveUserSectors = function () {
      $http.patch(apiUrl + '/users/' + vm.editting_user.id + '/sectors', {
        sectors: vm.selectedSectors
      }).then(function () {
        $state.reload();
      }, function (error) { console.log(error) });
    };

    vm.saveUser = function () {
      $http.patch(apiUrl + '/users/' + vm.editting_user.id, vm.editting_user)
        .then(function () {
          $state.reload();
        }, function (error) { console.log(error) });
    };

    vm.userCreateModal = function () {
      vm.creating_user = {};
      FoundationApi.publish('userCreateModal', 'open');
    };

    vm.createUser = function () {
      vm.creating_user.company_id = vm.company.id;

      vm.creating_user.display_name = vm.creating_user.name;

      $http.post(apiUrl + '/users', vm.creating_user)
        .then(function () {
          $state.reload();
        }, function (error) { console.log(error) });
    };

    vm.uploadFiles = function (file) {
      file.upload = Upload.upload({
        url: apiUrl + '/companies/' + vm.company.id + '/default_image',
        file: file
      });

      file.upload.then(function (response) {
        $timeout(function () {
          vm.company.default_image = response;
        });
      }, function (response) {
        if (response.status > 0) { console.log(response.status + ': ' + response.data); }
      });
    };

    if ($stateParams.id) {
      vm.fetchCompany($stateParams.id);
    }

    vm.fetchChannels();
    vm.fetchAllChannels();
  }
})();
